import { TableBody as TableBodyMui, TableBodyProps as TableBodyMuiProps } from '@mui/material';

export type TableBodyProps = TableBodyMuiProps;

export const TableBody = TableBodyMui;
